import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTable from 'components/organisms/Tables/EntitiesTable/EntitiesTable';

const StyledDatabaseEntitiesTable = styled(EntitiesTable)`
  ${ComponentStyles}
`;

StyledDatabaseEntitiesTable.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntitiesTable;
